import Add from './add';
import Dashboard from './dashboard';
import Edit from './edit';

export default {
  Dashboard,
  Edit,
  Add,
};
